import React from "react";
import { mapRoute } from './components/utils/Route'
import { Switch, BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/utils/ScrollToTop";

// Layouts
import AuthLayout from './layouts/AuthLayout'
import DashboardLayout from './layouts/DashboardLayout'
import EditorLayout from './layouts/EditorLayout'

// Home pages
import Dashboard from './pages/Dashboard'
import Profile from './pages/Profile'
import Settings from './pages/Settings'
import Premium from './pages/Premium'

// Auth pages
import Login from './pages/auth/Login'
import SignUp from './pages/auth/SignUp'

// Editor pages
import GrammarReport from "./pages/editor/GrammarReport"
import SentenceVariation from "./pages/editor/SentenceVariation"
import ParagraphVariation from './pages/editor/ParagraphVariation'
import Suggestions from './pages/editor/Suggestions'
import Sentiments from './pages/editor/Sentiments'
import Pacing from './pages/editor/Pacing'
import ChapterVariation from './pages/editor/ChapterVariation'
import DialogueAdverbs from './pages/editor/DialogueAdverbs'
import Cliches from './pages/editor/Cliches'
import Redundancies from './pages/editor/Redundancies'
import TagReport from './pages/editor/TagReport'
import UnnecessaryFillers from './pages/editor/UnnecessaryFillers'
import GenericDescription from './pages/editor/GenericDescription'
import ShowingVSTelling from './pages/editor/ShowingVSTelling'
import WritingStyleReport from "./pages/editor/WritingStyleReport";

const routes = [
	{
		path: "",
		component: AuthLayout,
		children: [
			{
				exact: true,
				path: "/login",
				component: Login,
			},
			{
				exact: true,
				path: "/signup",
				component: SignUp,
			},
		],
	},
	{
		path: "",
		component: DashboardLayout,
		children: [
			{
				path: "/",
				exact: true,
				component: Dashboard,
			},
			{
				exact: true,
				path: "/profile",
				component: Profile,
			},
			{
				exact: true,
				path: "/premium",
				component: Premium,
			},
			{
				exact: true,
				path: "/settings",
				component: Settings,
			},
		],
	},
	{
		exact: true,
		path: "/editor",
		component: EditorLayout,
		children: [
			{
				exact: true,
				path: "/grammar-report",
				component: GrammarReport,
			},
			{
				exact: true,
				path: "/sentence-variation",
				component: SentenceVariation,
			},
			{
				exact: true,
				path: "/paragraph-variation",
				component: ParagraphVariation,
			},
			{
				exact: true,
				path: "/suggestions",
				component: Suggestions,
			},
			{
				exact: true,
				path: "/sentiment-analysis",
				component: Sentiments,
			},
			{
				exact: true,
				path: "/pacing",
				component: Pacing,
			},
			{
				exact: true,
				path: "/chapter-variation",
				component: ChapterVariation,
			},
			{
				exact: true,
				path: "/adverbs",
				component: DialogueAdverbs,
			},
			{
				exact: true,
				path: "/cliches",
				component: Cliches,
			},
			{
				exact: true,
				path: "/redundancies",
				component: Redundancies,
			},
			{
				exact: true,
				path: "/tag-report",
				component: TagReport,
			},
			{
				exact: true,
				path: "/unnecessary-filler",
				component: UnnecessaryFillers,
			},
			{
				exact: true,
				path: "/generic-description",
				component: GenericDescription,
			},
			{
				exact: true,
				path: "/showing-vs-telling",
				component: ShowingVSTelling,
			},
			{
				exact: true,
				path: "/writing-style-report",
				component: WritingStyleReport,
			},
		],
	},
];

const Router = () => {
	return (
		<React.Suspense fallback={
			<div className='grid place-items-center fixed inset-0'>
				Loading...
			</div>
		}>
			<BrowserRouter>
				<ScrollToTop>
					<Switch>
						{routes.map(
							(route) => mapRoute(route)
						)}
					</Switch>
				</ScrollToTop>
			</BrowserRouter>
		</React.Suspense>
	)
}

export default Router